export default defineNuxtPlugin((nuxtApp) => {
  const router = nuxtApp.$router
  if (!router) return

  const originalOnError = router.onError.bind(router)
  router.onError = (error) => {
    const msg = typeof error === 'string' ? error : error?.message || ''
    if (
      (msg.includes('_nuxt/components/') && msg.includes('vue&type=style')) ||
      msg.includes("No match found for location with path '/_nuxt/'")
    ) {
      return
    }
    originalOnError(error)
  }
})
